import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUserOverview } from 'src/api/users-queries';
import { OrganizationalUnitsOverview } from 'src/types/users';

export const OrganizationalUnitsList = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const navigate = useNavigate();

  const { isLoading, data } = useGetUserOverview();

  const onRowClick = (row: OrganizationalUnitsOverview) => {
    navigate(`/account/organizational-units/${row.organizationId}/researchers`);
  };

  const headers = [
    { label: 'Name', key: 'name' },
    { label: 'Display name', key: 'displayName' },
    { label: 'Researchers', key: 'researchers' },
    { label: 'Studies', key: 'studies' },
    { label: 'Datasets', key: 'dataSets' },
  ];

  const transformedData = useMemo(
    () =>
      data?.organizationalUnits
        .filter(
          (organization) =>
            organization.organizationName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            organization.organizationDisplayName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((organization) => ({
          id: organization.organizationId,
          name: organization.organizationName,
          displayName: organization.organizationDisplayName,
          researchers: organization.researchers,
          studies: organization.studies,
          dataSets: organization.dataSources,
          onClick: () => onRowClick(organization),
        })) ?? [],
    [data, searchTerm],
  );

  return (
    <div className="flex flex-col gap-6 p-4 bg-background-dark-subdued rounded-lg">
      <TableV2
        headers={headers}
        data={transformedData}
        isLoading={isLoading}
        searchPlaceholder="Search organizational units"
        onSearch={(t) => setSearchTerm(t)}
      />
    </div>
  );
};
